// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Join Class Modal Styles - Exact Figma colors
   ========================================== */

/* Modal Overlay/Scrim */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Container */
.modal-container {
  width: 544px;
  max-width: calc(100vw - 48px);
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(76, 85, 91, 0.2);
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 40px;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal Header */
.modal-header {
  display: flex;
  justify-content: flex-end;
  padding: 16px 16px 0px;
}

.modal-close-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 2px;
  transition: background-color 0.2s ease;
}

.modal-close-btn:hover {
  background: rgba(226, 233, 237, 0.5);
}

.modal-close-btn:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Modal Content */
.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 0 40px;
}

.modal-text-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.modal-heading {
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.333;
  color: #21262A;
  margin: 0;
  text-align: left;
  width: 100%;
}

.modal-body {
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: #21262A;
  margin: 0;
  text-align: left;
  width: 100%;
}

/* Form */
.modal-form {
  width: 100%;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.field-label {
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5;
  color: #000000;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.text-input {
  width: 100%;
  height: 60px;
  padding: 0 16px;
  background: #FFFFFF;
  border: 1px solid rgba(0, 37, 74, 0.3);
  border-radius: 14px;
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  color: #21262A;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.text-input::placeholder {
  color: #859299;
}

.text-input:focus {
  outline: none;
  border-color: #1C60EA;
  box-shadow: 0 0 0 3px rgba(28, 96, 234, 0.1);
}

.text-input:disabled {
  background: #F5F5F5;
  cursor: not-allowed;
}

.text-input-error {
  border-color: #D32F2F;
}

.text-input-error:focus {
  border-color: #D32F2F;
  box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.1);
}

.field-error {
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #D32F2F;
  margin: 4px 0 0 0;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
}

/* Secondary Button (Back) */
.btn-secondary {
  min-width: 114px;
  height: 48px;
  padding: 10px 24px;
  background: transparent;
  border: 2px solid #00254B;
  border-radius: 9999px;
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.75;
  color: #00254B;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: rgba(0, 37, 75, 0.05);
}

.btn-secondary:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Primary Button (Join Challenge) */
.btn-primary {
  min-width: 183px;
  height: 48px;
  padding: 10px 24px;
  background: #00254B;
  border: none;
  border-radius: 9999px;
  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.75;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(.btn-disabled) {
  background: #001a36;
}

.btn-primary:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Disabled Button State */
.btn-disabled {
  background: rgba(0, 37, 75, 0.4);
  cursor: not-allowed;
}

/* Responsive Styles */
@media (max-width: 600px) {
  .modal-container {
    width: 100%;
    max-width: calc(100vw - 32px);
    gap: 20px;
    padding-bottom: 32px;
  }

  .modal-content {
    padding: 0 24px;
  }

  .modal-footer {
    padding: 0 24px;
  }

  .footer-actions {
    flex-direction: column-reverse;
    width: 100%;
  }

  .btn-secondary,
  .btn-primary {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/JoinClassModal.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,8DAA8D;EAC9D,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,6BAA6B;IAC7B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* ==========================================\n   Join Class Modal Styles - Exact Figma colors\n   ========================================== */\n\n/* Modal Overlay/Scrim */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Container */\n.modal-container {\n  width: 544px;\n  max-width: calc(100vw - 48px);\n  background: #FFFFFF;\n  border-radius: 16px;\n  box-shadow: 0px 4px 16px 0px rgba(76, 85, 91, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-bottom: 40px;\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Modal Header */\n.modal-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 16px 0px;\n}\n\n.modal-close-btn {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 2px;\n  transition: background-color 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  background: rgba(226, 233, 237, 0.5);\n}\n\n.modal-close-btn:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Modal Content */\n.modal-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 0 40px;\n}\n\n.modal-text-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.modal-heading {\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1.333;\n  color: #21262A;\n  margin: 0;\n  text-align: left;\n  width: 100%;\n}\n\n.modal-body {\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #21262A;\n  margin: 0;\n  text-align: left;\n  width: 100%;\n}\n\n/* Form */\n.modal-form {\n  width: 100%;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.field-label {\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.5;\n  color: #000000;\n}\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.text-input {\n  width: 100%;\n  height: 60px;\n  padding: 0 16px;\n  background: #FFFFFF;\n  border: 1px solid rgba(0, 37, 74, 0.3);\n  border-radius: 14px;\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #21262A;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.text-input::placeholder {\n  color: #859299;\n}\n\n.text-input:focus {\n  outline: none;\n  border-color: #1C60EA;\n  box-shadow: 0 0 0 3px rgba(28, 96, 234, 0.1);\n}\n\n.text-input:disabled {\n  background: #F5F5F5;\n  cursor: not-allowed;\n}\n\n.text-input-error {\n  border-color: #D32F2F;\n}\n\n.text-input-error:focus {\n  border-color: #D32F2F;\n  box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.1);\n}\n\n.field-error {\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #D32F2F;\n  margin: 4px 0 0 0;\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 40px;\n}\n\n.footer-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  width: 100%;\n}\n\n/* Secondary Button (Back) */\n.btn-secondary {\n  min-width: 114px;\n  height: 48px;\n  padding: 10px 24px;\n  background: transparent;\n  border: 2px solid #00254B;\n  border-radius: 9999px;\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.75;\n  color: #00254B;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background: rgba(0, 37, 75, 0.05);\n}\n\n.btn-secondary:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Primary Button (Join Challenge) */\n.btn-primary {\n  min-width: 183px;\n  height: 48px;\n  padding: 10px 24px;\n  background: #00254B;\n  border: none;\n  border-radius: 9999px;\n  font-family: 'AvenirNext forINTUIT', 'Avenir Next', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.75;\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary:hover:not(.btn-disabled) {\n  background: #001a36;\n}\n\n.btn-primary:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Disabled Button State */\n.btn-disabled {\n  background: rgba(0, 37, 75, 0.4);\n  cursor: not-allowed;\n}\n\n/* Responsive Styles */\n@media (max-width: 600px) {\n  .modal-container {\n    width: 100%;\n    max-width: calc(100vw - 32px);\n    gap: 20px;\n    padding-bottom: 32px;\n  }\n\n  .modal-content {\n    padding: 0 24px;\n  }\n\n  .modal-footer {\n    padding: 0 24px;\n  }\n\n  .footer-actions {\n    flex-direction: column-reverse;\n    width: 100%;\n  }\n\n  .btn-secondary,\n  .btn-primary {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
